const SDK_VERSION = '8.37.1';

export { SDK_VERSION };
